<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormRegion @submit="submit" :title="'Add Region'" :form="{}"></FormRegion>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import FormRegion from '@/views/admin/region/FormRegion'

export default {
  name: 'addregion',
  components: {
    FormRegion
  },
  methods: {
    submit (form) {
      let scope = this; 

      form.user = scope.$store.getters.currentUser.id

      axios.post(process.env.VUE_APP_API + '/region', form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.$router.push('/admin/regions/list')
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
